import React, { useState } from "react";
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { PettyWork } from "features/PettyWorks/types/petty-work.types";

interface CancelModalProps {
  show?: boolean;
  onCancelClick?: (reason: string | null) => void;
  onCloseClick?: () => void;
  record?: PettyWork | null;
}

const CancelModal = ({
  show,
  onCancelClick,
  onCloseClick,
  record,
}: CancelModalProps) => {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onCloseClick?.();
  };

  const handleConfirm = () => {
    onCancelClick?.(reason.trim() || null);
  };

  return (
    <Modal fade isOpen={show} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>Cancel — {record?.code ?? `#${record?.id}`}</ModalHeader>
      <ModalBody>
        <p className="text-muted mb-3">
          Once cancelled, this petty work will be closed and excluded from
          further operations. Any linked advance that hasn't been received
          yet is cancelled automatically; if one has already been received,
          cancellation will be blocked until it's refunded first.
        </p>
        <Label className="form-label">
          Reason <span className="text-muted fw-normal">(optional)</span>
        </Label>
        <Input
          type="textarea"
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Explain why this petty work is being cancelled…"
        />
        <p className="text-muted small mt-2 mb-0">
          The reason will be saved and visible on the timeline.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={handleClose}>Close</Button>
        <Button color="danger" onClick={handleConfirm}>Cancel petty work</Button>
      </ModalFooter>
    </Modal>
  );
};

export default CancelModal;
